import EntryActionTypes from '../../constants/EntryActionTypes';

export const createArchitecture = (factoryId, data) => ({
  type: EntryActionTypes.ARCHITECTURE_CREATE,
  payload: {
    factoryId,
    data,
  },
});

export const deleteArchitecture = (id) => ({
  type: EntryActionTypes.ARCHITECTURE_DELETE,
  payload: {
    id,
  },
});

export const fetchArchitecture = (factoryId) => ({
  type: EntryActionTypes.ARCHITECTURE_FETCH,
  payload: {
    factoryId,
  },
});
